import React from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  FormHelperText,
} from '@material-ui/core';
import {
  Controller,
  Control,
  UseFormRegister,
  FieldErrors,
} from 'react-hook-form';
import { ContactUsFormFields } from '../types';

type DcimDetailsProps = {
  control: Control<ContactUsFormFields>;
  register: UseFormRegister<ContactUsFormFields>;
  errors: FieldErrors<ContactUsFormFields>;
  dcimUrls: string[];
};

const DcimDetails = ({
  control,
  register,
  errors,
  dcimUrls,
}: DcimDetailsProps) => {
  return (
    <Box>
      <TextField
        label="Data Center Location"
        placeholder="Provide the Digital Realty site code(s) for the location(s)"
        required
        fullWidth
        {...register('dcimDataCenterLocation')}
        error={!!errors.dcimDataCenterLocation}
        helperText={errors.dcimDataCenterLocation?.message || ' '}
      />
      <FormControl fullWidth required error={!!errors.dcimUrl}>
        <InputLabel>URL</InputLabel>
        <Controller
          name="dcimUrl"
          control={control}
          render={({ field }) => (
            <Select
              {...field}
              label="URL"
              displayEmpty
              value={field.value || ''}
            >
              {dcimUrls.map(url => (
                <MenuItem key={url} value={url}>
                  {url}
                </MenuItem>
              ))}
            </Select>
          )}
        />
        <FormHelperText>{errors.dcimUrl?.message || ' '}</FormHelperText>
      </FormControl>

      <TextField
        label="Profile ID [DCIM NA/APAC only] > Profile ID / Client ID"
        placeholder="Provide your Digital Realty issued Profile / User ID"
        required
        fullWidth
        {...register('dcimProfileId')}
        error={!!errors.dcimProfileId}
        helperText={errors.dcimProfileId?.message || ' '}
      />
      <TextField
        label="DDIDs [DCIM Request only] > Data IDs"
        placeholder="Please provide a sample of the Data IDs you are contacting us about"
        required
        fullWidth
        {...register('dcimDdidSample')}
        error={!!errors.dcimDdidSample}
        helperText={errors.dcimDdidSample?.message || ' '}
      />
    </Box>
  );
};

export default DcimDetails;
